<template>
  <section class="main">
    <v-page-header :title="getPageTitle" />
    <div class="grid-container" v-if="this.$route.meta.method == 'create'">
      <div class="grid-x">
        <div class="cell medium-9 large-11">
          <div class="callout warning text-center">{{ $t('tours.create.status') }}</div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-x">
        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
          <v-action-buttons
            :items="getActionButtons"
            :isDisabled="objectFormDisabled"
            @actionClicked="onClickAction"
          />
          <v-form-message
            type="error"
            id="form-error"
            :message="objectError"
            @onClickAction="onClickDialogAction"
          />

          <v-form-message
            type="success"
            id="form-success"
            :message="objectSuccess"
            @onClickAction="onClickDialogAction"
          />

          <v-form-message
            type="default"
            :message="objectRemoveConfirm"
            :autoCloseTimeout="0"
            :showActionButtons="true"
            @onClickAction="onClickDialogAction"
          />

          <div class="box u-extra-medium-padding--bottom">
            <div class="grid-x grid-margin-x align-middle">
              <div class="cell medium-3">
                <div class="form-group" :class="{ 'form-group--error' : $v.object.kolonne.$error }">
                  <label for="form-field-kolonne">{{ $t('tours.kolonne') }}</label>
                  <v-select-kolonne
                    id="form-field-kolonne"
                    name="kolonne"
                    :placeholder="$t('select')"
                    v-model="object.kolonne"
                  />
                </div>
              </div>
              <div class="cell medium-3">
                <div
                  class="form-group"
                  :class="{ 'form-group--error' : $v.object.startdate.$error }"
                >
                  <label>{{ $t('search.from') }}</label>
                  <v-datepicker
                    class="form-control form-control--small form-control--date"
                    :placeholder="$t('search.from')"
                    :format="$t('search.from') + ' ' + $helpers.dateFormat"
                    :clearButton="true"
                    :monday-first="true"
                    :disabled-dates="$helpers.disabledDates"
                    :language="de"
                    v-model="object.startdate"
                  />
                </div>
              </div>

              <div class="cell medium-3">
                <div class="form-group" :class="{ 'form-group--error' : $v.object.enddate.$error }">
                  <label>{{ $t('search.till') }}</label>
                  <v-datepicker
                    class="form-control form-control--small form-control--date"
                    :placeholder="$t('search.till')"
                    :format="$t('search.till') + ' ' + $helpers.dateFormat"
                    :clearButton="true"
                    :monday-first="true"
                    :disabled-dates="{ days: [6, 0], to : new Date(object.startdate) }"
                    :language="de"
                    v-model="object.enddate"
                  />
                </div>
              </div>

              <div class="cell medium-3">
                <button
                  style="margin-top: 9px"
                  class="button"
                  :class="[searchActive ? 'hollow':'']"
                  v-on:click.prevent="showSearch"
                >
                  {{ $t('tours.button.searchform') }}
                  <span
                    v-show="!searchActive"
                  >{{ $t('tours.button.searchform.open') }}</span>
                  <span v-show="searchActive">{{ $t('tours.button.searchform.close') }}</span>
                </button>
              </div>
            </div>
          </div>

          <transition name="u-fade">
            <div v-show="searchActive">
              <div class="box">
                <!-- Step 1 Heading -->
                <div class="grid-x grid-margin-x">
                  <div class="cell medium-1">
                    <div class="c-circle-label">
                      <span class="c-circle-label__text">1</span>
                    </div>
                  </div>
                  <div class="cell medium-11">
                    <h2
                      class="u-extra-small-margin--bottom"
                    >{{ $t('tours.headline.companysearch') }}</h2>

                    <v-accordion>
                      <div class="grid-x grid-margin-x align-bottom">
                        <div class="cell small-auto">
                          <label for="form-field-companyname">{{ $t('tours.companyname') }}</label>
                          <v-customer-select
                            v-if="searchActive"
                            :selected-customers="object.search_companies"
                            @change-customers="onChangeCustomers($event)"
                          ></v-customer-select>
                        </div>

                        <div class="cell small-auto medium-3 u-extra-small-margin--top">
                          <button
                            class="button"
                            @click.prevent="addCustomersFromSearch"
                          >{{ $t('tours.company.add') }}</button>
                        </div>
                      </div>
                    </v-accordion>
                  </div>
                </div>
                <!-- EO Step 1-->
              </div>
              <transition name="u-fade">
                <div v-show="step2Active">
                  <div class="box">
                    <!-- Step 2 Heading -->
                    <div class="grid-x grid-margin-x">
                      
                      <div class="cell medium-1">
                        
                        <div class="c-circle-label">
                          <span class="c-circle-label__text">2</span>
                        </div>
                        
                      </div>
                      
                      <div class="cell medium-11">
                        <h2
                          class="u-extra-small-margin--bottom"
                        >{{ $t('tours.headline.projectsearch') }}</h2>

                        <v-accordion>
                          <div class="grid-x grid-margin-x">
                            <div class="cell small-auto medium-2">
                        
                                <h3>{{ $t('tours.qm.max.open') }}</h3>
                         
                            </div>
                            <div class="cell small-auto medium-3">
                              
                               <p v-if="search_error_qm" class="u-error text-center u-extra-small-margin--bottom">
                                  {{ $t('tours.error.search.qm') }}
                                </p>
                                
                               <div class="form-group form-group--row u-no-margin--bottom">
                                  <label for="form-field-qmmin" class="u-no-margin--bottom text-right">{{ $t('search.from') }} </label>
                                  <input
                                    type="number"
                                    inputmode="decimal"
                                    v-model="object.search_minqm"
                                    id="form-field-qmmin"
                                    name="qmmin"
                                    placeholder="qm"
                                    class="form-control form-control--small"
                                  />
                                  <label for="form-field-qmmax" class="u-no-margin--bottom text-right">{{ $t('search.till') }} </label>           
                                  <input
                                    type="number"
                                    inputmode="decimal"
                                    v-model="object.search_maxqm"
                                    id="form-field-qmmax"
                                    name="qmmax"
                                    placeholder="qm"
                                    class="form-control form-control--small"
                                  />     
                              
                                </div>
                                                             
                            </div>
                            <div class="cell small-auto">
                              <div class="loading-wrapper" :class="{ 'is-loading' : isLoading }">
                                <div
                                  class="loading-message"
                                  v-if="isLoading"
                                >{{ $t('results_loading') }}</div>
                                <span
                                  v-if="object.search_companies.length == 0"
                                >{{ $t('no_results_found') }}</span>

                                <section
                                  class="c-tourplan-company"
                                  v-for="(company, index) in object.search_companies"
                                  :key="index"
                                >
                                  <div
                                    class="c-tourplan-company__heading-select form-group form-group--check"
                                  >
                                    <label>
                                      <input
                                        type="checkbox"
                                        v-model="projectSearchItems.companies_managers"
                                        name="companies_managers[]"
                                        @change="onCheckCompanyManager(company.id)"
                                        :value="String(company.id)"
                                      />
                                      <i></i>
                                      <p class="c-tourplan-company__heading u-no-margin--bottom">
                                        <strong>{{ company.text }}</strong>
                                      </p>
                                    </label>
                                  </div>

                                  <div
                                    class="c-tourplan-company__manager-results"
                                    v-if="company.managers.length > 0"
                                  >
                                    <v-accordion-project-managers>
                                      <template slot="buttonlabel">
                                        <span
                                          class="c-tourplan-company__manager-heading u-extra-small-margin--bottom"
                                        >
                                          <strong>{{ $t('search.pm') }}</strong>
                                        </span>
                                      </template>
                                      <template slot="content">
                                        <ul class="c-tourplan-company__manager-select-list">
                                          <li
                                            class="u-extra-small-margin--bottom form-group form-group--check"
                                            v-for="(manager, index) in company.managers"
                                            :key="index"
                                          >
                                            <label>
                                              <input
                                                type="checkbox"
                                                v-model="projectSearchItems.companies_managers"
                                                name="companies_managers[]"
                                                :value="company.id + '-' + manager.id"
                                              />
                                              <i></i>
                                              {{ manager.name }}
                                            </label>
                                          </li>
                                        </ul>
                                      </template>
                                    </v-accordion-project-managers>
                                  </div>
                                </section>
                              </div>
                              <div class="grid-x text-right">
                                <div class="cell auto">
                                  <button
                                    @click.prevent="projectSearch"
                                    class="button"
                                  >{{ $t('tours.button.projectsearch') }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-accordion>
                      </div>
                    </div>
                    <!-- EO Step 2-->
                  </div>
                </div>
              </transition>
              <transition name="u-fade">
                <div v-show="step3Active">
                  <div class="box">
                    <!-- Step 3 Heading -->
                    <div class="grid-x grid-margin-x">
                      <div class="cell medium-1">
                        <div class="c-circle-label">
                          <span class="c-circle-label__text">3</span>
                        </div>
                      </div>
                      <div class="cell medium-11">
                        
                        <h2 class="u-extra-small-margin--bottom">{{ $t('tours.headline.projectresults') }}</h2>
                        
                        <button class="button outline secondary"
                          @click.prevent="toggleSearchHistory">
                          <span v-if="showSearchHistory">{{ $t('tours.searchhistory.buttonlabel.live') }}</span>
                          <span v-else>{{ $t('tours.searchhistory.buttonlabel.history') }}</span>
                        </button>

                        <v-accordion>
                          <div class="grid-x grid-margin-x align-bottom">
                            <div class="cell small-auto">
                              <v-table
                                class="tourplan-table"
                                :isLoading="searchResultsTableLoading"
                                :columns="searchResultsTableColumns"
                                :items="projectSearchItems.projectResults"
                                :showHeaderRow="true"
                                :showShowAll="false"
                                :useDetailRow="false"
                              >
                                <template slot="select" slot-scope="{ row }">
                                  <label>
                                    <input
                                      type="checkbox"
                                      name="routeObjects[]"
                                      :value="row.id"
                                      v-model="routeSelectedObjects"
                                    />
                                    <i></i>
                                  </label>
                                </template>

                                <template slot="project_number" slot-scope="{ row }">
                                  <p v-if="row.project_number" class="u-no-margin">
                                    <router-link
                                      :to="{ name : 'customers-update-customer-project', params : { customer : row.customer_id, project : row.id } }"
                                      class="table__subtil-link"
                                      :title="$t('update')"
                                    >{{ row.project_number }}</router-link>
                                  </p>
                                  <div
                                    :title="$t('project.error.nogeolocation')"
                                    v-if="!row.lat || !row.lon"
                                  >
                                    <svg  :title="$t('project.error.nogeolocation')"
                                    v-if="!row.lat || !row.lon" class="u-icon--geolocation-warning" role="presentation">
                                      <use
                                        xlink:href="/dist/sprite.svg#icon-globe"
                                        href="/dist/sprite.svg#icon-globe"
                                      />
                                    </svg>
                                  </div>
                                  <div v-if="projectHasRoute(row)" class="u-extra-small-margin--top">
                                    <div v-for="(route, index) in row.tour_routes" :key="index">
                                      <div
                                        v-if="route.tour_id != object.id"
                                        class="callout alert u-text-center"
                                      >
                                        <router-link
                                          :to="{ name : 'update-tour', params: {tour: route.tour_id} }"
                                          class="u-no-margin"
                                          :title="$t('update')"
                                        >{{ route.tour_number }}</router-link>
                                        <div>
                                          <small>({{ route.tour_startdate | moment('DD-MM-YYYY') }} - {{ route.tour_enddate | moment('DD-MM-YYYY') }})</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <div v-if="projectHasWeekPlanEntries(row)">
                                    <p class="u-extra-small-margin--top u-extra-small-margin--bottom u-text-center"><strong>Wochenplan Einträge:</strong></p>
                                    
                                    <div  class="callout alert u-text-center" v-for="(entry, index) in row.weekplan_entries" :key="index">
                                        <router-link
                                        :title="$t('update')"
                                        :to="{ name: 'update-day', params: {date: formattedStartDate(entry.startdate), kolonne: entry.kolonne }}"
                                        > Kolonne: {{ entry.kolonne}}  </router-link>
                                        <div>
                                            <small>{{ entry.startdate | moment('DD-MM-YYYY') }} - {{ entry.enddate | moment('DD-MM-YYYY') }}</small>
                                        </div>
                                    </div>
                                   
                                  </div>
                                </template>

                                <template slot="bauleiter" slot-scope="{ row }">
                                  <p
                                    v-if="row.account"
                                  >{{ row.account.profile.firstname }} {{ row.account.profile.lastname }}</p>
                                </template>

                                <template slot="company_name" slot-scope="{ row }">
                                  <p v-if="row.customer">{{ row.customer.company_name }}</p>
                                </template>

                                <template slot="address" slot-scope="{ row }">
                                  <p v-if="row.address">
                                    <strong>{{ row.address.zipcode }} {{ row.address.city }}</strong>
                                    <br />
                                    {{ row.address.street }} {{ row.address.housenumber }}
                                  </p>
                                </template>

                                <template slot="layers" slot-scope="{ row }" v-if="row.layers">
                                  <p
                                    class="u-extra-small-margin--bottom"
                                    v-for="(layer, index) in row.layers"
                                    :key="index"
                                  >
                                    <strong>{{ layer.subtype }}</strong>
                                  </p>
                                </template>

                                <template slot="openqm" slot-scope="{ row }" v-if="row.stats">
                                  <p>{{ row.stats.qm.open }} / {{ row.stats.qm.total }}</p>
                                </template>
                              </v-table>
                              <div class="grid-x">
                                <div class="cell small-12 text-right">
                                  <p>
                                    <strong>{{$t('sum.openqm')}}: {{ resultsOpenQM }}</strong>
                                  </p>
                                </div>
                              </div>

                              <div class="grid-x">
                                <div class="cell auto text-left">
                                  <button
                                    class="button outline secondary"
                                    @click.prevent="openSingleProjectSearch"
                                  >{{ $t('tours.button.open.projectsearch') }}</button>

                                  <button
                                    class="button outline secondary"
                                    @click.prevent="clearProjectSearchResults"
                                  >{{ $t('tours.button.delete.projectsearch') }}</button>
                                  
                                </div>
                                <div class="cell auto text-right">
                                  <span
                                    v-if="addingToTourPlan"
                                    class="loading-wrapper is-loading"
                                    style="margin-right: 40px;"
                                  >
                                    <span class="loading-message"></span>
                                  </span>
                                  <button
                                    class="button"
                                    @click.prevent="addProjectsToTourplan()"
                                    :disabled="routeSelectedObjects.length === 0"
                                  >{{ $t('tours.button.addtourplan') }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-accordion>
                      </div>
                    </div>
                    <!-- EO Step 3-->
                  </div>
                </div>
              </transition>
            </div>
            <!-- EO search step container -->
          </transition>
          <div class="box">
            <div>
              <div class="cell auto">
                <h2 class="u-extra-small-margin--bottom">Routeplanung</h2>

                <v-route-planner
                  :resize="!isLoading"
                  :addresses="object.routes"
                  :removeAddresses="removeAddresses"
                  :startCity="object.start_city"
                  :startAddress="object.start_address"
                  :startZipcode="object.start_zipcode"
                  :startLat="object.start_lat"
                  :startLon="object.start_lon"
                  :endCity="object.end_city"
                  :endAddress="object.end_address"
                  :endZipcode="object.end_zipcode"
                  :endLat="object.end_lat"
                  :endLon="object.end_lon"
                  ref="routeplanner"
                  @onAddressError="handleAddressError"
                  @onCalculateRouteError="onCalculateRouteError"
                  @onAddressUpdate="handleAddressUpdate"
                  @onEndPointError="handleEndpointError"
                  @onCalculateRoute="getOptimizedRoute"
                  @onEndpointUpdate="setEndpoints"
                  @onOptimizingStateChange="routeOptimizing = $event"
                />

                <section class="c-routeplanner u-extra-large-margin--top">
                  <div class="grid-x grid-margin-x align-bottom">
                    <div class="cell small-auto medium-6">
                      <div class="grid-x grid-margin-x">
                        <div class="cell auto">
                          <p class="h4 u-no-margin">{{ $t('tours.startpoint') }}</p>
                        </div>
                      </div>
                      <div class="grid-x grid-margin-x">
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="start_zipcode">{{ $t('form.zipcode') }}*</label>
                            <input
                              type="text"
                              name="start_zipcode"
                              id="start_zipcode"
                              class="form-control form-control--small"
                              v-model="object.start_zipcode"
                            />
                          </div>
                        </div>
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="start_address">{{ $t('form.street') }}</label>
                            <input
                              type="text"
                              name="start_address"
                              id="start_address"
                              class="form-control form-control--small"
                              v-model="object.start_address"
                            />
                          </div>
                        </div>
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="start_city">{{ $t('form.city') }}</label>
                            <input
                              type="text"
                              name="start_city"
                              id="start_city"
                              class="form-control form-control--small"
                              v-model="object.start_city"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cell small-auto medium-6">
                      <div class="grid-x grid-margin-x">
                        <div class="cell auto">
                          <p class="h4 u-no-margin">{{ $t('tours.endpoint') }}</p>
                        </div>
                      </div>
                      <div class="grid-x grid-margin-x">
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="end_zipcode">{{ $t('form.zipcode') }}*</label>
                            <input
                              type="text"
                              name="end_zipcode"
                              id="end_zipcode"
                              class="form-control form-control--small"
                              v-model="object.end_zipcode"
                            />
                          </div>
                        </div>
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="end_address">{{ $t('form.street') }}</label>
                            <input
                              type="text"
                              name="end_address"
                              id="end_address"
                              class="form-control form-control--small"
                              v-model="object.end_address"
                            />
                          </div>
                        </div>
                        <div class="cell auto">
                          <div class="form-group">
                            <label for="start_city">{{ $t('form.city') }}</label>
                            <input
                              type="text"
                              name="end_city"
                              id="end_city"
                              class="form-control form-control--small"
                              v-model="object.end_city"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="cell small-auto medium-2">
                      <div class="form-group">
                        <button
                          class="button"
                          :disabled="routeOptimizing"
                          @click.prevent="requestOptimizedRoute()"
                        >{{ $t('tours.button.optimizeroute') }}</button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="grid-x grid-margin-x align-center"
                    v-if="this.object.route_optimized === false"
                  >
                    <div class="callout alert small">
                      <p>{{ $t('tours.route_is_not_optimized')}}</p>
                    </div>
                  </div>
                </section>

                <v-table
                  class="c-tourplan-table"
                  :isLoading="tourplanResultsTableLoading"
                  :columns="tourplanResultsTableColumns"
                  :items="tourplanResultsTableItems"
                  :showHeaderRow="true"
                  :showShowAll="false"
                  :useDetailRow="false"
                  :reloadTable="tourplanResultsReloadTable"
                  :rowClass="(row, index) => row.has_error === true ? 'row-error' : ''"
                >
                  <template slot="delete" slot-scope="{ row }">
                    <label class="text-center">
                      <input
                        type="checkbox"
                        v-model="tourplanResultsTableItemsSelected"
                        name="tour_routes_selected[]"
                        :value="row.uid"
                        :disabled="row.has_error"
                        @change="onCheckTourplanItems"
                      />
                      <i></i>
                    </label>
                  </template>

                  <template slot="index" slot-scope="{ row }">
                    <p :data-uid="row.uid" class="c-tourplan-table__index">{{ row.sort_order }}</p>
                  </template>

                  <template slot="project_number" slot-scope="{ row }">
                    <p class="u-no-margin">
                      <router-link
                        :to="{ name : 'customers-update-customer-project', params : { customer : row.project.customer_id, project : row.project.id } }"
                        class="table__subtil-link"
                        :title="$t('update')"
                      >{{ row.project.project_number }}</router-link>
                    </p>
                  </template>

                  <template slot="company_name" slot-scope="{ row }">
                    <p
                      class="u-no-margin c-tourplan-table__company-name"
                      v-if="row.project && row.project.customer"
                    >{{ row.project.customer.company_name }}</p>
                  </template>

                  <template slot="address" slot-scope="{ row }" v-if="row.address">
                    <p class="u-extra-small-margin--bottom">
                      <strong>{{ row.address.zipcode }} {{ row.address.city }}</strong>
                    </p>
                    <p v-if="row.distance">{{ $t('tours.distance') }}: {{ row.distance }} KM</p>
                    <p
                      class="callout alert u-text-center"
                      v-if="row.has_error"
                    >{{ $t('tours.error.nogeocode') }}</p>
                  </template>

                  <template slot="comment" slot-scope="{ row }">
                    <strong v-if="row.project.site_comments">
                      <p>{{ row.project.site_comments }}</p>
                    </strong>
                  </template>

                  <template slot="tok" slot-scope="{ row }">
                    <p v-if="row.project.layer_tok">{{ $t('yes') }}</p>
                    <strong v-else class="u-color--primary">{{ $t('no') }}</strong>
                  </template>

                  <template slot="mixingplants" slot-scope="{ row }">
                    <ul>
                      <li
                        class="u-extra-small-margin--bottom form-group form-group--check"
                        v-for="(mixingplant, index) in row.mixingplants"
                        :key="index"
                      >
                        <label>
                          <input
                            type="checkbox"
                            v-model="projectSelectedMixingplants"
                            :value="row.uid + '_' + mixingplant.id"
                          />
                          <i></i>

                          <strong>
                            <em>({{ parseFloat(mixingplant.distance).toFixed(2) }} KM)</em>
                          </strong>
                        </label>
                        <p
                          class="u-no-margin u-extra-small-margin--bottom"
                        >  <span class="c-ranking" :class="rankingClass(mixingplant.ranking)"></span> {{ $helpers.limitString(mixingplant.name, 45, '...') }}</p>
                        <p class="u-no-margin">
                          <strong>{{ mixingplant.address.zipcode }} {{ mixingplant.address.city }}</strong>
                        </p>
                      </li>
                    </ul>
                  </template>

                  <template slot="media" slot-scope="{ row }">
                    <router-link
                      :to="{ name : 'customers-view-customer-project-media', params : { customer : row.project.customer_id, project : row.project.id } }"
                      v-if="row.project.uploads.length >= 1"
                      class="button button--action button--action--files button--small"
                      :title="$t('media')"
                    >{{ $t('media') }}</router-link>
                  </template>
                </v-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-project-search-modal
      :isVisible="projectSearchModal.isVisible"
      v-model="projectSearchModal.isVisible"
      :currentSearchResults="projectSearchItems.projectResults"
      @addProject="addProjectFromModal"
    ></v-project-search-modal>
  </section>
</template>
<script>
import PageHeader from "./../partials/PageHeader";
import SelectKolonne from "./../partials/Forms/SelectKolonne";
import ActionButtons from "./../partials/Foundation/ActionButtons";
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import Table from "./../partials/Foundation/Table";
import Pagination from "./../partials/Foundation/Pagination";
import Accordion from "./../partials/Foundation/Accordion";
import RoutePlanner from "./RoutePlanner";
import AccordionProjectManagers from "./AccordionPMList";
import { required } from "vuelidate/lib/validators";
import FormMessage from "../partials/Forms/FormMessage";
import CustomerSelect from "../partials/CustomerSelect";
import ProjectSearchModal from "../partials/ProjectSearchModal";

export default {
  name: "TourCrud",
  data() {
    return {
      projectSearchModal: {
        isVisible: false
      },
      showSearchHistory: false,
      de: de,
      isLoading: false,
      objectError: null,
      objectSuccess: null,
      objectFormDisabled: false,
      objectRemoveConfirm: null,
      searchActive: false,
      step2Active: false,
      step3Active: false,
      search_error_qm: false,
      object: {
        startdate: "",
        enddate: "",
        kolonne: "",
        start_city: "",
        start_address: "",
        start_zipcode: "",
        start_lat: "",
        start_lon: "",
        end_lat: "",
        end_lon: "",
        end_city: "",
        end_address: "",
        end_zipcode: "",
        routes: [],
        route_optimized: true,
        search_companies: [],
        search_minqm: null,
        search_maxqm: null,
        search_projects: []
      },
      routeOptimizing: false,
      tourplanResultsReloadTable: false,
      tourplanResultsCurrentPage: this.$route.query.page || 1,
      tourplanResultsTableItemsPerPage: 20,
      tourplanResultsTableItemsCount: 0,
      tourplanResultsTableItems: [],
      tourplanResultsTableLoading: false,
      tourplanResultsTableColumns: [
        { key: "delete", width: "30px" },
        { key: "index" },
        {
          key: "project_number",
          label: this.$t("weeks.project.number"),
          width: "150px"
        },
        {
          key: "company_name",
          label: this.$t("tours.companyname"),
          width: "150px"
        },
        {
          key: "address",
          label: this.$t("weeks.project.address"),
          width: "180px"
        },
        {
          key: "comment",
          label: this.$t("form.upload.comment")
        },
        {
          key: "tok",
          label: this.$t("form.project.layer_tok"),
          width: "50px"
        },
        { key: "mixingplants", label: this.$t("tours.mixingplants") },

        { key: "media", width: "30px" }
      ],
      tourplanResultsTableItemsSelected: [],
      routeSelectedObjects: [],
      projectListLoading: true,
      projectSearchItems: {
        companies_managers: [],
        projectResults: []
      },
      projectSearchStatuses: "open,busy",
      projectSelectedMixingplants: [],
      addresses: [],

      removeAddresses: [],
      searchResultsTableLoading: false,
      searchResultsTableColumns: [
        { key: "select", label: "" },
        { key: "project_number", label: this.$t("weeks.project.number") },
        { key: "bauleiter", label: this.$t("pm") },
        { key: "company_name", label: this.$t("weeks.project.company_name") },
        { key: "address", label: this.$t("weeks.project.address") },
        { key: "layers", label: this.$t("weeks.project.layers") },
        { key: "openqm", label: this.$t("weeks.project.openqm") }
      ],
      addingToTourPlan: false
    };
  },
  components: {
    vCustomerSelect: CustomerSelect,
    vAccordionProjectManagers: AccordionProjectManagers,
    vPageHeader: PageHeader,
    vActionButtons: ActionButtons,
    vDatepicker: Datepicker,
    vTable: Table,
    vPagination: Pagination,
    vSelectKolonne: SelectKolonne,
    vAccordion: Accordion,
    vRoutePlanner: RoutePlanner,
    vFormMessage: FormMessage,
    vProjectSearchModal: ProjectSearchModal
  },
  watch: {
    $route: {
      handler: function() {
        this.onUpdateObject();
      },
      deep: true
    }
  },
  created: function() {
    this.onUpdateObject(true);
  },
  computed: {
    resultsOpenQM: function() {
      let smeters = 0;
      this.routeSelectedObjects.forEach(item1 => {
        this.projectSearchItems.projectResults.forEach(item2 => {
          if (item1 === item2.id) {
            smeters = smeters + item2.stats.qm.open;
          }
        });
      });

      return this.$helpers.formatNumber(smeters);
    },
    
    isCreateMethod: function() {
      return this.$route.meta.method === "create";
    },
    isUpdateMethod: function() {
      return this.$route.meta.method === "update";
    },
    isDuplicateMethod: function() {
      return this.$route.meta.method === "duplicate";
    },
    getActionButtons: function() {
      let buttons = [];
      buttons.push({
        action: "save"
      });

      if (this.isUpdateMethod && this.object) {
        buttons.push({
          action: "delete"
        });
      }

      buttons.push({
        action: "cancel",
        router: {
          name: "tours"
        }
      });
      return buttons;
    },
    getPageTitle: function() {
      let pagetitle = this.$t("tours." + this.$route.meta.method + ".title");
      if (this.isUpdateMethod && this.object && this.object.tour_number) {
        pagetitle += ": " + this.object.tour_number;
      }
      return pagetitle;
    }
  },
  validations: function() {
    return {
      object: {
        kolonne: {
          required
        },
        startdate: {
          required
        },
        enddate: {
          required
        }
      }
    };
  },
  methods: {
        
    formattedStartDate: function(startdate) {
        return this.$moment(startdate).format('YYYY-MM-DD');
    },
     
    rankingClass: function (ranking) {
        if (ranking == '') {
            ranking = 'none';
        }
        return 'c-ranking--' + ranking;
    },
      
    toggleSearchHistory: function() {
      this.showSearchHistory = !this.showSearchHistory;
      
      if (this.showSearchHistory) {
        this.handleSearchHistory();
      }else{
        this.projectSearch();
      }
    },
    
    addProjectFromModal: function(project) {
      this.tourplanResultsReloadTable = true;
      
      // add project to results table
      this.projectSearchItems.projectResults.push(project);
      
      // add project id to the array of route selections for delivery to final tour route object
      this.routeSelectedObjects.push(project.id);
      
      this.projectSearchModal.isVisible = false;
      
      this.resetTourResultsReloadTable();
    },

    clearProjectSearchResults: function() {
      this.projectSearchItems.projectResults = [];
    },

    resetTourResultsReloadTable: function() {
      this.$nextTick(function() {
        // $nextTick callback function after vue updates DOM.
        this.tourplanResultsReloadTable = false;
      });
    },

    onClickAction: function(action) {
      switch (action) {
        case "save":
          this.onSubmitObject();
          break;
        case "delete":
          this.onOpenDeleteDialog();
          break;
      }
    },

    onClickDialogAction: function(id, action) {
      this.objectError = null;
      this.objectSuccess = null;
      this.objectRemoveConfirm = null;
      
      switch (action) {
        case "yes":
          this.onDeleteObject();
          break;
      }
      
    },

    onCheckCompanyManager: function(id) {
      this.projectSearchItems.companies_managers.forEach(
        function(item, index) {
          let idLength = String(id).length + 1;
          if (item.substring(0, idLength) === id + "-") {
            this.projectSearchItems.companies_managers.splice(index, 1);
          }
        }.bind(this)
      );
    },

    addCustomersFromSearch: function() {
      this.step2Active = true;
      this.customerListLoading = false;

      this.object.search_companies.forEach(company => {
        if (
          !this.projectSearchItems.companies_managers.includes(
            String(company.id)
          )
        ) {
          this.projectSearchItems.companies_managers.push(String(company.id));
        }
        if (company.managers) {
          company.managers.forEach(manager => {
            if (
              !this.projectSearchItems.companies_managers.includes(
                company.id + "-" + manager.id
              )
            ) {
              this.projectSearchItems.companies_managers.push(
                company.id + "-" + manager.id
              );
            }
          });
        }
      });
    },

    onChangeCustomers: function(companies) {
      this.object.search_companies = companies;
    },

    projectSearch: function(projectIds = [], skipSelected = false) {
      window.app.$helpers.logger("Project Search Started ...");
      this.showSearchHistory = false; // hide search history if activated

      let _vm = this;
      _vm.searchResultsTableLoading = true;
      _vm.step3Active = true;
      
      // Used to check if we need to get history of projects

      let promise = this.$api;

      promise.clearParams();
      promise.addParam("status", this.projectSearchStatuses);

      if (projectIds && projectIds.length > 0) {
        
        promise.addParam("project_ids", projectIds.join());

      } else {
        // Strip out single company items. Those are items without a '-' separator,
        let filterAccountIds = this.projectSearchItems.companies_managers.filter(
          manager => manager.includes("-")
        );
        let locationAccountIds = filterAccountIds.join();

        if (locationAccountIds) {
          promise.addParam("location_account_ids", locationAccountIds);
        }
      }

      return promise
        .get("projects")
        .then(response => {
          
          // We filter out projects based on qm filter options
          let projectResults = _vm.filterProjectsOpenQm(response.data.data);

          // Make project results selected as default. This automatically sets each project search result as selected.
          _vm.routeSelectedObjects = [];
          projectResults.forEach(project => {
            _vm.routeSelectedObjects.push(project.id);
          });
          
          // Assign results to the results table for visual output
          _vm.projectSearchItems.projectResults = projectResults;
           
        })
        .catch(error => {
          return [];
        })
        .finally(() => {
          _vm.searchResultsTableLoading = false;
        });
    },

    handleSearchHistory: function() {
      /**
       * Checks our projects for saved projects and replaces the live data with the saved projects historical content 
       */
      window.app.$helpers.logger("Show search history ... ");
      this.projectSearchItems.projectResults = this.object.search_projects;
      
      // Reset selected items
      this.routeSelectedObjects = [];
      this.object.search_projects.forEach(project => {
        if (project.selected) {
           this.routeSelectedObjects.push(project.id);
        }
      });
      
    },

    filterProjectsOpenQm: function(projects) {
      /**
       * This function sends filters out projects not belonging to the qm min an max settings in the form
       */
      let _vm = this;
      let filteredProjects = projects;
      _vm.search_error_qm = false;
      
      // Check our min
      if (_vm.object.search_minqm === null) _vm.object.search_minqm = 0; 
      
      // Check for our max 
      if (_vm.object.search_maxqm !== null) {
          window.app.$helpers.logger("Search QM with max: " + _vm.object.search_maxqm + " min: " + _vm.object.search_minqm);
          
          if (parseInt(_vm.object.search_minqm) > parseInt(_vm.object.search_maxqm)) {
             window.app.$helpers.logger("Min value is greater than Max value! Exiting... ");
             _vm.search_error_qm = true;
             return;
          }
          
          filteredProjects = projects.filter(function(el) {
            return (
              (parseInt(el.stats.qm.open) <= parseInt(_vm.object.search_maxqm)) && (parseInt(el.stats.qm.open) >= parseInt(_vm.object.search_minqm))
            );
          });
      }else{
          window.app.$helpers.logger("Search QM with no max. Min is: " + _vm.object.search_minqm);
          
          filteredProjects = projects.filter(function(el) {
            return (
              parseInt(el.stats.qm.open) >= parseInt(_vm.object.search_minqm)
            );
          });
      };

      return filteredProjects;
    },

    projectHasRoute: function(project) {
      return project && project.tour_routes && project.tour_routes.length > 0;
    },
    
    projectHasWeekPlanEntries: function(project) {
         return project && project.weekplan_entries && project.weekplan_entries.length > 0;
    },

    addProjectsToTourplan: function() {
      window.app.$helpers.logger("Adding projects to tourplan ...");
      
      let _vm = this;
      _vm.tourplanResultsTableLoading = true;
      _vm.tourplanResultsReloadTable = true;

      // visual indication that the user added to the tourplan
      _vm.addingToTourPlan = true;
      setTimeout(function() {
        _vm.addingToTourPlan = false;
      }, 300);

      _vm.routeSelectedObjects.forEach(function(id, index) {
        _vm.projectSearchItems.projectResults.filter(function(el) {
          if (el.id === id) {
            if (
              _vm.tourplanResultsTableItems.indexOf(
                _vm.tourplanResultsTableItems.find(
                  row => row.project && row.project.id == id
                )
              ) === -1
            ) {
              let name = el.address.zipcode + " " + el.address.city;
              let uid = "p" + el.id;
              _vm.tourplanResultsTableItems.push({
                uid: uid,
                project: el,
                object_type: "project",
                sort_order: index,
                address: el.address,
                name: name
              });
              _vm.tourplanResultsTableItemsSelected.push(uid);
            }
          }
        });
      });

      _vm.tourplanResultsTableLoading = false;

      this.object.routes = this.tourplanResultsTableItems;
      
      this.setTourplanSortOrder();
      
      this.object.route_optimized = false;

      this.resetTourResultsReloadTable();
    },

    removeFromMap: function(rowUid) {
      this.removeAddresses = [];
      this.removeAddresses.push(
        this.tourplanResultsTableItems.find(row => row.uid == rowUid)
      );
    },

    deSelectFromRouteSelections: function(id) {
      this.routeSelectedObjects.splice(
        this.routeSelectedObjects.indexOf(
          this.routeSelectedObjects.find(row => row == id)
        )
      );
    },

    removeFromTourplan: function(rowUid) {
      this.removeFromMap(rowUid);

      this.tourplanResultsTableItems.splice(
        this.tourplanResultsTableItems.indexOf(
          this.tourplanResultsTableItems.find(row => row.uid == rowUid)
        ),
        1
      );
      this.object.routes = this.tourplanResultsTableItems;
      this.setTourplanSortOrder();
      this.deSelectFromRouteSelections(event.target.value);
      this.object.route_optimized = false;
    },

    onCheckTourplanItems: function() {
      let routes = [];

      this.tourplanResultsTableItemsSelected.forEach(item => {
        let key = this.tourplanResultsTableItems.findIndex(
          row => row.uid == item
        );
        if (
          key !== undefined &&
          this.tourplanResultsTableItems[key] !== undefined
        ) {
          routes.push(this.tourplanResultsTableItems[key]);
        }
      });
      this.object.routes = routes;
      this.setTourplanSortOrder();
      this.object.route_optimized = false;
    },

    setTourplanSortOrder: function() {
      let sortIdx = 1;
      let items = [];
      this.tourplanResultsTableItems.forEach(item => {
        if (
          this.tourplanResultsTableItemsSelected.find(
            row => row === item.uid
          ) !== undefined
        ) {
          item.sort_order = sortIdx;
          sortIdx++;
        } else {
          item.sort_order = null;
        }
        items.push(item);
      });
      this.tourplanResultsTableItems = items;
    },

    requestOptimizedRoute: function() {
      if (this.routeOptimizing) {
        return;
      }
      this.objectError = null;
      this.$refs.routeplanner.prepareRoute();
    },

    getOptimizedRoute: function(routeUids) {
      window.app.$helpers.logger("Getting optimized route ...");
      
      this.tourplanResultsReloadTable = true;
      
      let optimizedRoutes = [];
      let sortIdx = 1;
      routeUids.forEach(uid => {
        this.tourplanResultsTableItems.find(row => {
          if (row.uid === uid.address) {
            row.sort_order = sortIdx;
            row.distance = uid.distance;
            optimizedRoutes.push(row);
            sortIdx++;
          }
        });
      });
      
      this.tourplanResultsTableItems = _.union(
        optimizedRoutes,
        this.tourplanResultsTableItems
      );
      
      this.object.route_optimized = true;

      this.resetTourResultsReloadTable();
    },

    handleAddressUpdate: function(address, latitude, longitude) {
      
      let itemIndex = this.tourplanResultsTableItems.findIndex(
        row => row.uid == address.uid
      );
      
      if (itemIndex !== -1) {
        
        this.getProjectMixingplants(latitude, longitude).then(response => {
          this.tourplanResultsTableItems[itemIndex].mixingplants = response;
          this.setTourplanSortOrder();
        });
        
      }
    },

    handleAddressError: function(address) {
      
      let newRoutes = [];
      this.tourplanResultsTableItems.forEach(item => {
        
        if (address.uid === item.uid) {
          item.has_error = true;
          var selectedIndex = this.tourplanResultsTableItemsSelected.indexOf(
            item.uid
          );
          if (selectedIndex !== -1) {
            this.tourplanResultsTableItemsSelected.splice(selectedIndex, 1);
          }
        }
        
        newRoutes.push(item);
        
      });
      
      this.tourplanResultsTableItems = newRoutes;
      
      this.setTourplanSortOrder();
    },

    handleEndpointError: function(message) {
      this.objectError = message;
    },

    onCalculateRouteError: function(message) {
      this.objectError = message;
    },

    showSearch: function() {
      this.searchActive = !this.searchActive;
    },

    handleSavedSearchSteps: function() {
      
      window.app.$helpers.logger("Handling saved search steps ... ");
      
      if (this.object.search_companies.length > 0) {
        this.searchActive = true;
        this.onChangeCustomers(this.object.search_companies);
        this.addCustomersFromSearch();
      }

      if (this.object.search_projects.length > 0) {
        let projectIds = [];
        this.routeSelectedObjects = [];
        this.object.search_projects.forEach(project => {
          if (project.selected && project.selected === true) {
            this.routeSelectedObjects.push(project.id);
          }
          projectIds.push(project.id);
        });
        this.projectSearch(projectIds, true);
      }
    },

    handleSavedMixingplants: function() {
      
      if (this.object.routes.length > 0) {
        
        this.object.routes.forEach(route => {
          
          if (route.mixingplants.length > 0) {
            
            route.mixingplants.forEach(plant => {
              if (plant.selected && plant.selected === true) {
                this.projectSelectedMixingplants.push(
                  route.uid + "_" + plant.id
                );
              }
              
            });
            
          }
          
        });
      }
    },

    onUpdateObject: function(firstLoad) {
      if (this.isCreateMethod) {
        this.objectLoading = false;
        return;
      }

      if (firstLoad) {
        this.tourplanResultsReloadTable = true;
      }

      this.objectLoading = true;

      window.app.$helpers.logger("Getting tour... ");

      let promise = this.$api
        .clearParams()
        .get("tours/" + this.$route.params.tour + "/get");

      return promise
        .then(
          function(response) {
            this.object = response.data.data;

            if (this.object.routes) {
              this.tourplanResultsTableItems = this.object.routes;
              this.tourplanResultsTableItemsSelected = this.tourplanResultsTableItems.map(
                item => {
                  return item.uid;
                }
              );
              this.setTourplanSortOrder();
            }
 
            this.handleSavedSearchSteps();

            this.handleSavedMixingplants();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.objectError = error;
          }.bind(this)
        )
        .finally(
          function() {
            this.objectLoading = false;
            this.resetTourResultsReloadTable();
          }.bind(this)
        );
    },

    onSubmitObject: function() {
      
      this.objectError = null;
      this.objectSuccess = null;
      this.objectFormDisabled = true;

      this.$v.object.$touch();

      if (this.$v.object.$invalid) {
        this.objectError = this.$t("form.error_form");
        this.objectFormDisabled = false;
        return;
      }

      let endpoint;
      let successMessage;

      if (this.isUpdateMethod && this.object.id) {
        endpoint = "tours/" + this.object.id + "/update";
        successMessage = this.$t("tours.update.success");
      } else if (this.isCreateMethod || this.isDuplicateMethod) {
        endpoint = "tours/create";
        successMessage = this.$t("tours.create.success");
      }

      let routes = [];
      this.tourplanResultsTableItems.forEach(route => {
        
        if (route.sort_order !== null && route.sort_order > 0) {
          
          if (route.mixingplants) {
            route.mixingplants = route.mixingplants.map(
              function(mp) {
                return {
                  id: mp.id,
                  name: mp.name,
                  address: mp.address,
                  phone: mp.phone,
                  distance: mp.distance,
                  ranking: mp.ranking,
                  selected: this.projectSelectedMixingplants.includes(
                    route.uid + "_" + mp.id
                  )
                };
              }.bind(this)
            );
          }

          routes.push(route);
        }
      });
      this.object.routes = routes;

      let searchProjects = [];
      this.projectSearchItems.projectResults.forEach(project => {
        if (this.routeSelectedObjects.includes(project.id)) {
          searchProjects.push({
            id: project.id,
            selected: true,
            account: project.account,
            tour_routes: project.tour_routes,
            tour_number: project.tour_number,
            layers: project.layers,
            stats: project.stats,
            address: project.address,
            project_number: project.project_number,
            account_id: project.account_id,
            customer_id: project.customer_id,
            lat: project.lat,
            lon: project.lon,
            customer: {
              company_name: project.customer.company_name,
              contact_person: project.customer.contact_person,
            }
          });
        }
      });
      this.object.search_projects = searchProjects;

      let promise = this.$api.clearParams().post(endpoint, this.object);

      promise
        .then(
          (response => {
            this.objectSuccess = successMessage;

            if (this.isCreateMethod || this.isDuplicateMethod) {
              this.$router.push({
                name: "update-tour",
                params: {
                  tour: response.data.data.id
                }
              });
            }
          }).bind(this)
        )
        .catch(
          (error => {
            this.objectError = this.$t(error.response.data.message);
          }).bind(this)
        )
        .finally(
          (() => {
            this.objectFormDisabled = false;
          }).bind(this)
        );
    },

    onOpenDeleteDialog: function() {
      this.objectRemoveConfirm = this.$t("tours.message.delete");
    },

    onDeleteObject: function() {
      this.objectError = null;
      this.objectSuccess = null;
      this.objectFormDisabled = true;
      this.objectRemoveConfirm = null;

      let promise = this.$api
        .clearParams()
        .post("tours/" + this.$route.params.tour + "/delete");

      promise
        .then(
          (response => {
            this.$router.push({
              name: "tours"
            });
          }).bind(this)
        )
        .catch(
          (error => {
            this.objectError = this.$t(error.response.data.message);
          }).bind(this)
        )
        .finally(
          (() => {
            this.objectFormDisabled = false;
          }).bind(this)
        );
    },

    openSingleProjectSearch: function() {
      // open modal
      this.projectSearchModal.isVisible = true;
    },

    getProjectMixingplants: function(latitude, longitude) {
      
      if (latitude && longitude) {
        let promise = this.$api
          .clearParams()
          .addParam("latitude", latitude)
          .addParam("longitude", longitude)
          .addParam("distance", 100)
          .addParam("limit", 3)
          .addParam("sortby", "distance")
          .get("mixingplants");

        return promise
          .then(response => {
            if (response.data.data) {
              return response.data.data;
            }
          })
          .catch(error => {
            window.app.$helpers.logger(error);
          });
      }
      
    },

    setEndpoints: function(value) {
      this.object.start_lat = value.start_lat.toString();
      this.object.start_lon = value.start_lng.toString();
      this.object.end_lat = value.end_lat.toString();
      this.object.end_lon = value.end_lng.toString();
    }
  }
};
</script>
